//-----------------------------------------------------
// Production only JS
//-----------------------------------------------------

if (process.env.APP_ENV === 'prod') {
    require('../js/trackers/sentry');
}

// -----------------------------------------------------
// Global vendor
// -----------------------------------------------------

import Alpine from 'alpinejs';
import Modal from 'bootstrap/js/dist/modal';
import Offcanvas from 'bootstrap/js/dist/offcanvas';

window.Alpine = Alpine;
// Las otras páginas usan esta copia. Si también importaran el módulo,
// Webpack lo ejecutaría otra vez y el fondo gris se quedaría al cerrar.
window.bootstrap = { Modal, Offcanvas };

import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/tab';

//-----------------------------------------------------
// Global JS
//-----------------------------------------------------

import 'shop/assets/js/analytics/gtm';
import 'shop/assets/js/component/form/newsletter-subscription';
import 'shop/assets/js/component/form/show-password';
import 'shop/assets/js/component/shared/login-modal';
import 'shop/assets/js/component/shared/modal-autofocus';
import 'shop/assets/js/component/shared/menu-responsive-horizontal';
import 'shop/assets/js/component/shared/mobile-accordion';
import 'shop/assets/js/component/shared/scheduled-delivery-post-code-checker';
import 'shop/assets/js/component/shared/slider/slider';
import 'shop/assets/js/component/shared/tidio';
import 'shop/assets/js/component/shared/toast';
import 'shop/assets/js/component/shared/tooltip';
import 'shop/assets/js/component/shared/trustpilot';
import 'shop/assets/js/component/shared/video-responsive';
import 'shop/assets/js/component/twig/club-member-acquisition';
import 'shop/assets/js/connectif/index';

//-----------------------------------------------------
// Global CSS
//-----------------------------------------------------

import 'shop/assets/scss/index.scss';
